import { CreateStyled } from '@emotion/styled';

const withTransientProps: Parameters<CreateStyled>[1] = {
  shouldForwardProp: (propName: string) => !propName.startsWith('$'),
};

// Use named export instead of default export to avoid circular dependency issues
export { withTransientProps };
export default withTransientProps;
